<div class="dateslider-container" #dateSliderContainer>
  <qpoint-toolbar-btn iconClass="angle-left" (btnClick)="onDatePrevious()">
  </qpoint-toolbar-btn>
  <kendo-datepicker [(value)]="datePickerDate" (valueChange)="onValueInPickerChanged($event)" [activeView]="activeView" [bottomView]="bottomView" #datePicker></kendo-datepicker>
  <span (click)="toggleDatePicker()">{{ date | qPointDateFormat:format }}</span>
  <qpoint-toolbar-btn iconClass="angle-right" (btnClick)="onDateNext()">
  </qpoint-toolbar-btn>
</div>
